import React from 'react';
import _ from 'lodash';
import { Button, Dropdown, Menu, Tooltip, Row, Col } from 'antd';
import { CopyFilled, DownOutlined } from '@ant-design/icons';
import CopyButton from '../../../copy-button';
var modes = ['code', 'tree', 'preview', 'view'];

function SelectMode(_ref) {
  var {
    mode,
    setMode
  } = _ref;
  var menu = /*#__PURE__*/React.createElement(Menu, {
    onClick: e => setMode(e.key)
  }, modes.map(m => /*#__PURE__*/React.createElement(Menu.Item, {
    key: m
  }, _.startCase(m))));
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "Switch mode"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    overlay: menu
  }, /*#__PURE__*/React.createElement(Button, {
    type: "link",
    size: "small"
  }, _.startCase(mode), " ", /*#__PURE__*/React.createElement(DownOutlined, null))));
}

export default function OutputBar(_ref2) {
  var {
    json,
    mode,
    setMode
  } = _ref2;
  var copyProps = {
    textToCopy: JSON.stringify(json),
    title: 'Copy output',
    buttonStyle: {
      type: 'link'
    },
    icon: /*#__PURE__*/React.createElement(CopyFilled, {
      style: {
        color: 'white'
      }
    })
  };
  return /*#__PURE__*/React.createElement(Row, {
    align: "middle",
    justify: "end"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(SelectMode, {
    mode: mode,
    setMode: setMode
  }), /*#__PURE__*/React.createElement(CopyButton, copyProps)));
}